import {
    Component,
    OnInit,
    OnDestroy,
    HostBinding,
    ViewContainerRef,
} from '@angular/core';
import {
    StorageService,
    AuthenticationService,
    RoutingService,
    WebsocketService,
    AppToastrService
} from '../../../services';
import {STATE_NAMES} from '../../../common';
import {StateService, TransitionService} from '@uirouter/angular';
import {Subscription} from 'rxjs';
import {DayEvents, Message} from '../../../models';
import * as moment from 'moment';

@Component({
    selector: 'app-header',
    templateUrl: './header.html',
    providers: [WebsocketService]
})
export class GlobalHeaderComponent implements OnInit, OnDestroy {
    links: any[];
    homeState: string;
    user: any = {};
    noticeSubject: Subscription;
    cloSubject: Subscription;
    indexSelected: number;
    isIpad: any;
    imageUrl: string | null;
    title: any;
    clientID: number;

    @HostBinding('class.active') opened = false;
    @HostBinding('class.activeUser') openedUserDrp = false;

    constructor(private authenticationService: AuthenticationService,
                private stateService: StateService,
                private el: ViewContainerRef,
                private route: RoutingService,
                private  websocket: WebsocketService,
                private toast: AppToastrService,
                private transitionService: TransitionService,
                private storage: StorageService) {
        this.clientID = this.storage.userId;

        this.route.sharedTitle.subscribe(title => {
            this.title = title;
        });
        this.storage.localItemChanged().subscribe((res) => {
            if (res && (res.hasOwnProperty('currentUser') || res.hasOwnProperty('userImage'))) {
                this.user = this.storage.user;
                this.imageUrl = this.storage.image;
            }
        });
        this.isIpad = navigator.userAgent.match(/iPad/i) !== null;
    }

    ngOnInit() {
        this.user = this.storage.user;
        this.imageUrl = this.storage.image;
        this.homeState = STATE_NAMES.home;
    }

    ngOnDestroy() {
        if (this.noticeSubject) {
            this.noticeSubject.unsubscribe();
        }
        if (this.cloSubject) {
            this.cloSubject.unsubscribe();
        }
    }

    onLogout() {
        this.websocket.removeAll();
        this.authenticationService.logout();
    }

    redirectToPage(url) {
        this.route.go(url);
    }

    showDrpdown(event, index) {
        this.indexSelected = index;
        if (event.target.parentNode.className === 'item' && this.isIpad) {
            this.opened = true;
        }
    }

    showUserDrpdown() {
        setTimeout(() => {
            this.openedUserDrp = !this.openedUserDrp;
        }, 1);
    }
}
